import { render, staticRenderFns } from "./articleedit.vue?vue&type=template&id=536aee12&scoped=true"
import script from "./articleedit.vue?vue&type=script&lang=js"
export * from "./articleedit.vue?vue&type=script&lang=js"
import style0 from "./articleedit.vue?vue&type=style&index=0&id=536aee12&prod&scoped=true&lang=css"
import style1 from "./articleedit.vue?vue&type=style&index=1&id=536aee12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "536aee12",
  null
  
)

export default component.exports